module.exports = __webpack_public_path__ + "images/line2.3f010678.webp";